module.exports = __webpack_public_path__ + "static/strafe2-cefb7798f474df2bc2b6333965c01cd4.mp4";